export default __webpack_public_path__ + "static/vegetables-4735ae84de13ef59fdf84e8a6385b3b7.png";